import { render, staticRenderFns } from "./Youtube.vue?vue&type=template&id=64d73892&scoped=true"
var script = {}
import style0 from "./Youtube.vue?vue&type=style&index=0&id=64d73892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d73892",
  null
  
)

export default component.exports